// libs
import React, {Fragment, useState} from 'react';
// components
import FormModal from './status-modal';
import AddressModal from './address-modal';
import ImagePreview from '../../components/image-preview-box';
import Button from 'react-bootstrap/Button';
import PrintErrorMsg from '../../components/print-error-msg';
// config & functions 
import config from '../../config';

function Table({list, orgInfo, token, paginationNo}) {
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
	const [ShowAddressBox, setShowAddressBox] = useState(false);
    const [RowData, setRowData] = useState(0);
    const [PreviewImage, setPreviewImage] = useState(false);
    const [PreviewImagePath, setPreviewImagePath] = useState(false);

    const handleStatusModal = ({domain, userAccountId, orgId, orderId, paymentStatus, fulfillmentStatus, fulfillmentCarrier, trackingNumber, trackingUrl, shippedAt, deliveredAt}) => {
        setRowData({domain, userAccountId, orgId, orderId, paymentStatus, fulfillmentStatus, fulfillmentCarrier, trackingNumber, trackingUrl, shippedAt, deliveredAt});
        setShowAddressBox(false);
        setShowFormModalBox(true);
    }

    const handleAddressModal = ({orderId, name, email, phoneNo, address, city, state, pincode}) => {
        setRowData({orderId, name, email, phoneNo, address, city, state, pincode});
        setShowFormModalBox(false);
        setShowAddressBox(true);
    }
	
    const handleViewImage = (status, imgName, domain) => {
        setPreviewImagePath(`${config.assets.products}/sas-ecommerce/${domain}/products/large/${imgName}`);
        setPreviewImage(status);
    }

    const PrintImage = ({img, domain}) => {
        if(img) {
            let sa = img.split(",");
            return <div className='border bg-secondary rounded-circle d-flex justify-content-center align-items-center' style={{width: '40px', height: '40px'}} onClick={e => handleViewImage(true, sa[0], domain)}>
                <img src={`${config.assets.products}/sas-ecommerce/${domain}/products/thumbnail/${sa[0]}`} className='img-fluid' style={{width: '40px', height: '40px', borderRadius: '50%'}} />
            </div>
        } else {
            return <div className='border bg-secondary rounded-circle' style={{width: '40px', height: '40px'}}></div>
        }
    }

    const getPaymentLabel = (data) => {
        const method = (data?.payment_method || '').toLowerCase();
        const gateway = (data?.paymentGateway || '').toLowerCase();
        if (method === 'cod') return 'COD';
        if (method === 'prepaid') {
            if (gateway === 'razorpay') return 'Prepaid (Razorpay)';
            if (gateway === 'cashfree') return 'Prepaid (Cashfree)';
            if (gateway === 'payu') return 'Prepaid (PayU)';
            return 'Prepaid';
        }
        return data?.payment_method || 'N/A';
    }

    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <tbody>
                        {list.map((data,i) => {
                            return <Fragment key={Math.random()}>
                                <tr style={{background: '#cdcdcd'}} className="border">
                                    <td style={{background: '#cdcdcd', padding: '0.8rem 0rem'}} className="text-dark fw-bold" valign="middle"><span className="text-dark ms-3">{pNo + '.' + i}</span></td>
                                    <td style={{background: '#cdcdcd', padding: '0.8rem 0rem'}} valign="middle">
                                        <div className="d-flex align-items-center">
                                            <div className="ms-2 text-dark fw-bold" style={{minWidth: '500px'}}>
                                                <div className="d-flex mt-1">
                                                    <span className="text-dark me-1 fw-bold">{data?.order_id} |</span> 
                                                    <span className="text-primary me-2 fw-bold">{getPaymentLabel(data)}</span> 
                                                    <span className="text-dark fw-bold me-3">Rs {data?.total_amount || 0}/-</span>
                                                    {data?.offer_code && <span className="text-dark fw-bold px-2 border bg-white"><span className="text-success">Offer:</span> {data.offer_code} (-Rs {data.discount_amount}/-)</span>}
                                                    <span className="text-dark fw-bold px-2 border bg-white"><span className="text-danger">Payment:</span> {data?.paymentStatus || 'N/A'}</span>
                                                    <span className="text-dark fw-bold px-2 border bg-white"><span className="text-primary">Order Status:</span> {data?.orderStatus || 'N/A'}</span>
                                                </div>
                                                <div className="d-flex mt-1">
                                                    <span className="text-dark me-2 fw-bold fs-12rem"><u>Order By:</u> {data?.buyer_user_name || ''}</span> 
                                                    <span className="text-dark me-2 fw-bold fs-12rem"><u>Ship to:</u> {data?.shipToName || ''}</span> 
                                                    <span className="text-dark me-2 fw-bold fs-12rem"><u>Ordered on:</u> {data?.date_time || ''}</span> 
                                                </div>
                                                <div className="d-flex mt-1">
                                                    <span className="text-dark me-2 fw-bold fs-12rem"><u>Comments:</u> {data?.comments || ''}</span> 
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{background: '#cdcdcd'}} valign="middle" className="text-end">
                                        <div className="btn-group" role="group" aria-label="button group">
                                            <Button variant="secondary" onClick={() => handleAddressModal({orderId: data?.order_id, name: data?.shipToName, email: data?.shipToEmail, phoneNo: data?.shipToPhoneNo, address: data?.shipToAddress, city: data?.shipToCity, state: data?.shipToState, pincode: data?.shipToPincode})} className="fs-14rem border-0 text-white" style={{minWidth: '125px'}}>View Address</Button>
                                            <Button variant="secondary" onClick={() => handleStatusModal({domain: data?.domain, userAccountId: data?.fk_buyer_user_account_id, orgId: data?.fk_org_account_id, orderId: data?.order_id, paymentStatus: data?.paymentStatus, fulfillmentStatus: data?.fulfillmentStatus, fulfillmentCarrier: data?.fulfillmentCarrier, trackingNumber: data?.trackingNumber, trackingUrl: data?.trackingUrl, shippedAt: data?.shippedAt, deliveredAt: data?.deliveredAt})} className="fs-14rem border-0 text-white" style={{minWidth: '125px'}}>Update Status</Button>
                                        </div>
                                    </td>
                                </tr>
                                {data.orderItems && data.orderItems.length > 0 ? <tr key={Math.random()} className="border">
                                    <td colSpan={3} className="py-2">
                                        <div className="table-responsive">
                                            <table className="table table-sm fs-14rem mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{minWidth: '100px'}}>Image</th>
                                                        <th style={{minWidth: '200px'}}>SKU Id</th>
                                                        <th style={{minWidth: '250px'}}>Product</th>
                                                        <th style={{minWidth: '100px'}}>MRP</th>
                                                        <th style={{minWidth: '100px'}}>Listing Price</th>
                                                        <th style={{minWidth: '85px'}}>Quantity</th>
                                                        <th style={{minWidth: '100px'}}>Total Price</th>
                                                        <th style={{minWidth: '120px'}}>Color</th>
                                                        <th style={{minWidth: '120px'}}>Size</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.orderItems.map(v => {
                                                        return <tr key={Math.random()}>
                                                            <td><PrintImage img={v.product_image} domain={data.domain} /></td>
                                                            <td>{v.skuid}</td>
                                                            <td>{v.product_name}</td>
                                                            <td>{v.mrp}</td>
                                                            <td>Rs {v.listing_price}/-</td>
                                                            <td>{v.quantity}</td>
                                                            <td>Rs {v.total_price}/-</td>
                                                            <td>{v.color_label}</td>
                                                            <td>{v.size_label}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>: <tr key={Math.random()} className="border"><td colSpan={3}><PrintErrorMsg msg={'No order items available'} /></td></tr>}
                            </Fragment>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowFormModalBox) ? <FormModal setshowformmodalbox={setShowFormModalBox} rowdata={RowData} token={token} orginfo={orgInfo} /> : null}
            {(ShowAddressBox) ? <AddressModal setshowformmodalbox={setShowAddressBox} rowdata={RowData} token={token} orginfo={orgInfo} /> : null}
            {(PreviewImage)? <ImagePreview imagepath={PreviewImagePath} handleviewimagefn={handleViewImage} />:null}
        </>
    } else {
        return null;
    }
}

export default Table;